/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown>, message: NonNullable<unknown> }} Snapshot_History_Commit_Option_LabelInputs */



/**
* | output |
* | --- |
* | "Commit by {user}: {message}" |
*
* @param {Snapshot_History_Commit_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_commit_option_label = /** @type {((inputs: Snapshot_History_Commit_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Commit_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Commit par ${i?.user} : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Commit durch ${i?.user}: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impegnati da ${i?.user}: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Подтвердить до ${i?.user}: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Confirmado por ${i?.user}: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交者 ${i?.user}: ${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.user} によるコミット: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.user} द्वारा प्रतिबद्धता: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Confirmação por ${i?.user}: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Commit by ${i?.user}: ${i?.message}`)
});